var component = require('../../../lib/js/component.js');

var CloudinaryVideo = function () {
  var $video, $playBtn, $pauseBtn, isHeroWide, isHeroFind;
  var self = this;

  this.initialize = function (element, options) {
    var videoPath = this.$element.data('video-path');
    var remoteFolder = this.$element.data('remote-folder');
    isHeroWide = $(this.$element).parents('.HeroWide').length > 0;
    isHeroFind = $(this.$element).parents('.HeroFind').length > 0;

    if (videoPath) {
      var $fallbackImage = this.$element.find('.CloudinaryVideo__fallbackImage');

      // use cloudinary to render the video
      $video = $($.cloudinary.video(remoteFolder + videoPath, {
        controls: false,
        autoplay: true,
        loop: true,
        muted: true,
        quality: "auto",
        fetch_format: "auto"
      }));

      // move the fallback image into the video tag
      $fallbackImage.appendTo($video);

      $video.addClass('hidden-xs');
      $video.addClass('CloudinaryVideo__video');

      // add the video to the CloudinaryVideo element
      $video.appendTo(this.$element);

      $playBtn = this.$element.find("#videoPlay");
      $pauseBtn = this.$element.find("#videoPause");

      if($playBtn && $playBtn.length && $pauseBtn && $pauseBtn.length && $video && $video.length){
        $playBtn.hide();
        $pauseBtn.show();
        $playBtn.on('keydown click', this.checkEventTriggers.bind(this));
        $pauseBtn.on('keydown click', this.checkEventTriggers.bind(this));
      }
    }
  };

  this.checkEventTriggers = function(evt){
    // herowide accepts click while previous code only accepted enter or spacebar keydown

    // allow click for hero wide
    if ((isHeroWide || isHeroFind) && evt.type == "click") 
      this.togglePlayPause(evt);

    if (evt.keyCode == 13 || evt.keyCode == 32) 
      this.togglePlayPause(evt);

  }

  this.togglePlayPause = function(evt){
    evt.preventDefault();

    $pauseBtn.toggle();
    $playBtn.toggle();

    if($video[0].paused){
      $video[0].play();
      $pauseBtn.focus();
    } else {
      $video[0].pause();
      $playBtn.focus();
    }
    
    // toggle tabindex values
    var playTabIndex = $playBtn.attr("tabindex");
    var pauseTabIndex = $pauseBtn.attr("tabindex");
    $playBtn.attr("tabindex", pauseTabIndex);
    $pauseBtn.attr("tabindex", playTabIndex);
  }
};

module.exports = component(CloudinaryVideo);
